module.exports = __webpack_public_path__ + "img/station-img_1.4f1dbb7f.png";